import $axios from '@/core/api-config'
import { store } from '@/store'

class ChatService {
  addMessage ({ chatId, bookId, text }) {
    return $axios.post(`/api/chats/message/${chatId}/${bookId}`, { text: text })
  }

  getMessages ({ chatId, bookId, page, limit = 50 }) {
    return $axios.get(`/api/chats/messages/${chatId}/${bookId}?page=${page}&limit=${limit}`)
  }

  uploadAttachment ({ chatId, data }) {
    const headers = {
      'Content-Type': 'multipart/form-data',
      auth: store.state.auth.token
    }

    return $axios.post(`/api/chats/attachment/${chatId}`, data, headers)
  }

  deleteAttachments (ids) {
    return $axios.delete('/api/chats/attachment/', { data: { ids: ids } })
  }

  updateAttachments ({ messageId, ids }) {
    return $axios.put(`/api/chats/attachment/${messageId}`, { ids: ids })
  }

  updateMessageStatus ({ chatId }) {
    return $axios.put(`/api/chats/status/${chatId}`)
  }

  updateMutedAt ({ chatId, mutedAt }) {
    return $axios.put(`/api/chats/mute/${chatId}`, { mutedAt: mutedAt })
  }
}

export const chatService = new ChatService()
